export default {
    methods: {
        clearZeroAmount(fieldPath, refName) {
            // Split path e.g., "check.check_amount" -> ["check", "check_amount"]
            const keys = fieldPath.split('.');
            let obj = this;
            for (let i = 0; i < keys.length - 1; i++) {
                obj = obj[keys[i]];
                if (!obj) return; // exit if path invalid
            }

            const lastKey = keys[keys.length - 1];
            const value = obj[lastKey];
            const numeric = parseFloat((value || '').toString().replace(/[^\d.]/g, '')) || 0;

            if (numeric === 0) obj[lastKey] = '';

            if (refName && this.$refs[refName]) {
                this.$refs[refName].resetValidation();
            }
        },

        defaultZero(fieldPath) {
            const keys = fieldPath.split('.');
            let obj = this;

            // Navigate down the nested object
            for (let i = 0; i < keys.length - 1; i++) {
                if (!obj[keys[i]]) return; // stop if path doesn't exist
                obj = obj[keys[i]];
            }

            const lastKey = keys[keys.length - 1];
            const value = obj[lastKey];

            // Convert empty, null, or undefined to 0
            if (value === '' || value === null || value === undefined) {
                obj[lastKey] = 0;
            } else {
                // Optional: ensure numeric
                const num = Number(value);
                if (!isNaN(num)) obj[lastKey] = num;
            }
        },
    }
};
